import { useVoiceUI } from './useVoiceUI';

export const usePersonalVoices = () => useVoiceUI(s => s.personalVoices);
